import NextIcon from '@assets/images/common/icon/arrow/next.svg';
import React from 'react';
import { Link } from 'react-router-dom';

interface Article {
  to: string;
  title: string;
  date?: string;
}

interface Props {
  popularArticles: Article[];
  newsArticles: Article[];
  onNavigateToNews: () => void;
}

const ArticleSidebar: React.FC<Props> = ({ popularArticles, newsArticles, onNavigateToNews }) => {
  return (
    <aside className='inline-flex h-full w-[240px] flex-[0_0_auto] flex-col gap-12 border-l border-l-gray-200 bg-gray-50 px-4 py-6 align-top lg:flex lg:w-full lg:px-[22px] lg:py-[34px]'>
      <div className=''>
        <h2 className='mb-3 text-sm font-semibold'>人気の記事ランキング</h2>
        {popularArticles.length > 0 ? (
          <ul className='flex flex-col gap-1'>
            {popularArticles.map((article, index) => (
              <li
                className='rounded-md bg-white'
                key={index}
              >
                <Link
                  to={article.to}
                  className='flex gap-2 px-[13px] py-3 transition-colors hover:text-primary-500'
                >
                  <span className='font-montserrat text-sm font-semibold text-primary-500'>
                    {index + 1}
                  </span>
                  <p className='line-clamp-2 text-xs font-medium leading-[1.6]'>{article.title}</p>
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className='text-xs text-gray-500'>人気の記事がありません。</p>
        )}
      </div>

      <div className=''>
        <h2 className='mb-3 text-sm font-semibold'>お知らせ</h2>
        {newsArticles.length > 0 ? (
          <ul className='flex flex-col gap-1'>
            {newsArticles.map((article, index) => (
              <li
                className='rounded-md bg-white'
                key={index}
              >
                <Link
                  to={article.to}
                  className='flex flex-col gap-1 px-[13px] py-3 transition-colors hover:text-primary-500'
                >
                  <time
                    dateTime={article.date}
                    className='text-[10px] text-gray-400'
                  >
                    {article.date}
                  </time>
                  <p className='line-clamp-2 text-xs font-medium leading-[1.6]'>{article.title}</p>
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className='text-xs text-gray-500'>お知らせがありません。</p>
        )}
        <div className='mt-4 flex justify-end'>
          <button
            onClick={onNavigateToNews}
            className='inline-flex h-[25px] items-center gap-[6px] rounded-[100px] border border-gray-200 bg-gray-50 px-4 text-xs transition-opacity hover:opacity-80'
          >
            お知らせ一覧
            <img
              src={NextIcon}
              alt=''
              width='9'
              height='9'
              loading='lazy'
            />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default ArticleSidebar;
